import { get, post, remove } from "@/utils/request"
import { debounce } from "lodash-es"

// 转拼音
export const getCnPy = (data: any) =>
  post<any>('/cost-cloud-support/common/cn_2_py', data)

export const refreshSession = (data: any) =>
  get<any>('/cost-cloud-support/common/keepalive', data)

// 通用表达式计算接口
export const calcByServer = (data: any) => post<any>('/cost-cloud-support/common/calc', data)

// 单位转换
export const getUnitCollection = () => get<Record<string, number>>('/cost-cloud-indicator/unit_convert/map')

// 单位别名接口
export const getUnitAliasList = () => get<ListResT<any>>('/cost-cloud-indicator/unit_alias/page')

// 获取造价上传url
export const getCostUploadUrlApi = (params) => get<any>('/cmp-indicator/cost/project_upload_info', params)
// 获取造价下载url
export const getCostDownUrlApi = (params) => get<any>('/cmp-indicator/cost/project_download_url', params)

// 获取投资测算上传url (工投资测算-科目-附件上传地址接口)
export const getInvestEstimateUploadUrlApi = (params) => get<any>('/cmp-indicator/invest_estimate_coll/upload_info', params)
// 获取投资测算下载url (工投资测算-科目-附件下载地址接口)
export const getInvestEstimateDownUrlApi = (params) => get<any>('/cmp-indicatorinvest_estimate_coll/download_url', params)

// 获取锁接口
export const getIndicatorLock = (params, config = {}) => get<any>('/cmp-indicator/common/lock', params, config)
// 防抖后的方法，300ms 内多次调用只执行一次
// export const getIndicatorLock = debounce(_getIndicatorLock, 300)
// 释放锁接口
export const releaseIndicatorLock = (params) => get<any>('/cmp-indicator/common/lock/release', params)
// export const releaseIndicatorPostLock = (params) => post<any>('/cmp-indicator/common/lock/release', params)
export const releaseIndicatorPostLock = (params: LockReleaseParams) => post<any>(`/cmp-indicator/common/lock/release?code=${params.code}&resourceId=${params.resourceId}&requestId=${params.requestId}`)

// 基础配置
export const getCommonConfig = () => get<any>('/cmp-indicator/common/basic_config_info',)

// 获取云工程上传url
export const getCloudProjectUploadUrlApi = (params) => post<any>('/cost-cloud-cloudproject/file/queryUploadAddress', params)
// 获取云工程下载url
export const getCloudProjectDownUrlApi = (params) => post<any>('/cost-cloud-cloudproject/file/queryDownloadAddress', params)

// icator/custom_data/create 自定义数据新增接口
// ownerType	所有者类型，0：平台，1：租户，2：用户		false	
// integer(int32)
// username	用户账号（用户数据时）		false	
// string
// name	名称（自定义业务名称）		false	
// string
// code	编码（自定义业务标识）		false	
// string
// content	内容		false	
// string
// sort	序号（1，2...）
// 
export enum CustomDataOwnerType {
  Platform = 0,
  Tenant = 1,
  User = 2,
}
interface CreateCustomDataParams {
  id?: any
  ownerType: CustomDataOwnerType
  username: string
  name: string
  code: string
  content: string
  sort: number
  meta?: {
    [key: string]: any
  }
}
interface LockReleaseParams {
  code: string
  resourceId: string
  requestId: string
}
// 新增自定义接口，业务 code 在此定义
export enum CreateCustomDataCode {
  IndexFeature_zy = 'IndexFeature_zy', // 指标分析特征值
  IndexFeature_yt = 'IndexFeature_yt', // 指标分析特征值
}
export const createCustomData = (params: CreateCustomDataParams) => post<any>('/cmp-indicator/custom_data/create', params)

// 自定义数据编辑接口
export const updateCustomData = (params: CreateCustomDataParams) => post<any>('/cmp-indicator/custom_data/update', params)

// 自定义数据列表
export const getCustomDataList = (params: any) => post<any>('/cmp-indicator/custom_data/page', params)

// 自定义数据删除接口
export const deleteCustomDataById = (params: any) => remove('/cmp-indicator/custom_data/delete', params)
// 自定义数据删除接口（根据code）
export const deleteCustomDataByCode = (params: any) => post('/cmp-indicator/custom_data/delete_by_code', params)
